/**
 * Copyright 2016 xdot GmbH
 * Author: Marius Runde
 * Date: 30.06.2016
 */

'use strict';

import React from 'external/react';
import PropTypes from 'external/prop-types';
import { Title, translation } from 'plugin/liferay-widgets-react-web';
import { Button, Container, FormCheck, FormGroup } from 'external/react-bootstrap';
import { SendChannels } from '../constants/Constants';

class MultiSubscriptionEditForm extends React.Component {

    constructor(props){
        super(props);
    }

    withCtx(s){
        return this.props.formId + '.' + s;
    }

    updateSubscriptions(topic, sendChannel, e) {
        const subscription = this.props.formData.subscriptions.find(sub => sub.topic === topic);

        if (subscription) {
            const checked = e.target.checked;
            const channels = subscription.channels ? subscription.channels.slice() : [];

            if (checked && !channels.includes(sendChannel)) {
                channels.push(sendChannel);
            } else if (!checked && channels.includes(sendChannel)) {
                const index = channels.indexOf(sendChannel);
                channels.splice(index, 1);
            }

            const updatedSubscriptions = this.props.formData.subscriptions.map(sub => {
                if (sub.topic === topic) {
                    return { ...sub, channels };
                }
                return sub;
            });

            this.props.onChange({
                ...this.props.formData,
                subscriptions: updatedSubscriptions
            });
        }
    }

    updateAllTopicSendChannels(sendChannel, activated) {
        const updatedSubscriptions = this.props.formData.subscriptions.map(subscription => {
            const channels = subscription.channels ? subscription.channels.slice() : [];

            if (activated && !channels.includes(sendChannel)) {
                channels.push(sendChannel);
            } else if (!activated && channels.includes(sendChannel)) {
                const index = channels.indexOf(sendChannel);
                channels.splice(index, 1);
            }

            return { ...subscription, channels };
        });

        this.props.onChange({
            ...this.props.formData,
            subscriptions: updatedSubscriptions
        });
    }

    render(){
        const subscriptions = this.props.formData.subscriptions;

        return (
            <fieldset>
                { subscriptions && subscriptions.length > 0 &&
                    <React.Fragment>
                        <Title title={"Abonnement verwalten: " + subscriptions[0].title}/>
                        <Container className="py-3">
                            <table className="multi-subscription-table">
                                <thead>
                                <tr>
                                    <th scope="col"></th>
                                    <th scope="col">E-Mail-Benachrichtigungen</th>
                                    <th scope="col">Push-Benachrichtigungen</th>
                                </tr>
                                </thead>
                                <tbody>
                                {subscriptions.map((subscription, index) => (
                                    <tr key={index}>
                                        <th scope="row">
                                            {translation.trans(subscription.topic.substring(0, subscription.topic.indexOf('#')))}
                                        </th>
                                        <td>
                                            <FormGroup>
                                                <FormCheck
                                                    checked={subscription.channels.includes(SendChannels.Email)}
                                                    onChange={this.updateSubscriptions.bind(this, subscription.topic, SendChannels.Email)}
                                                />
                                            </FormGroup>
                                        </td>
                                        <td>
                                            <FormGroup>
                                                <FormCheck
                                                    checked={subscription.channels.includes(SendChannels.Push)}
                                                    onChange={this.updateSubscriptions.bind(this, subscription.topic, SendChannels.Push)}
                                                />
                                            </FormGroup>
                                        </td>
                                    </tr>
                                ))}
                                </tbody>
                                { subscriptions.length > 1 &&
                                    <tfoot>
                                        <tr>
                                            <td></td>
                                            <td>
                                                <Button
                                                    variant="primary"
                                                    onClick={() => this.updateAllTopicSendChannels(SendChannels.Email, true)}
                                                >
                                                    Alles auswählen
                                                </Button>
                                                <Button
                                                    variant="outline-primary"
                                                    onClick={() => this.updateAllTopicSendChannels(SendChannels.Email, false)}
                                                >
                                                    Auswahl aufheben
                                                </Button>
                                            </td>
                                            <td>
                                                <Button
                                                    variant="primary"
                                                    onClick={() => this.updateAllTopicSendChannels(SendChannels.Push, true)}
                                                >
                                                    Alles auswählen
                                                </Button>
                                                <Button
                                                    variant="outline-primary"
                                                    onClick={() => this.updateAllTopicSendChannels(SendChannels.Push, false)}
                                                >
                                                    Auswahl aufheben
                                                </Button>
                                            </td>
                                        </tr>
                                    </tfoot>
                                }
                            </table>

                        </Container>
                    </React.Fragment>
                }
            </fieldset>
        );
    }
}

MultiSubscriptionEditForm.propTypes = {
    formId: PropTypes.string,
    onChange: PropTypes.func,
    formData: PropTypes.object
};

export default MultiSubscriptionEditForm;



// WEBPACK FOOTER //
// ./js/components/MultiSubscriptionEditForm.jsx